import 'uni-pages';import 'uni-h5';import App from './App'

import "static/css/global.css";
import {GetInfo} from 'utils/index.js'


import Vue from 'vue'
import store from './store/index.js'; // 引入 store
import './uni.promisify.adaptor'
import images from '@/components/images/images.vue'
// import UploaderImg from '@/components/UploaderImg/UploaderImg.vue'
import {onShareAppMessage} from '@/utils/shareMixin'
import { config } from '@/config'

// 全局变量
Vue.prototype.$config = config;

Vue.use(images)
// Vue.use(UploaderImg)
Vue.config.productionTip = false 
Vue.prototype.GetInfo = GetInfo;
Vue.prototype.$toastSuccess = (res,icon='success')=>{
  try {
  return  new Promise((resolve, reject) => {
      setTimeout(()=>{
				uni.showToast({
					title:res,
					icon: icon
				})
			},50)
      setTimeout(function (){
        resolve()
      },1000)
    })
  }catch(r){

  }
};
// 定义全局混入
Vue.mixin({
  onShareAppMessage
});
App.mpType = 'app'
const app = new Vue({
  ...App,
  store // 挂载 store
})
app.$mount()










